import styled from "styled-components";

import { useTranslate } from "@similarweb/i18n-provider";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { numberFilter } from "app/filters/numberFilter";

import { Title } from "./StyledComponents";

const COUNT_PLACEHOLDER_WIDTH = 100;
const COUNT_PLACEHOLDER_HEIGHT = 32;

const CountPlaceholder = styled(PixelPlaceholderLoader)`
    border-radius: 4px;
    margin-right: 8px;
`;

interface IAdsCountTitleProps {
    totalCount: number;
    isLoading: boolean;
    labelKey: string;
    dataAutomation?: string;
}

/**
 * The gallery's "N Ads" heading.
 *
 * While the first response is still on its way there is no count to show, and rendering the default
 * zero reads as "this advertiser has no ads" — so a placeholder stands in until the number exists.
 * Later refreshes (paging, filters) keep the previous count on screen instead of flashing back to a
 * placeholder.
 */
export const AdsCountTitle = ({ totalCount, isLoading, labelKey, dataAutomation }: IAdsCountTitleProps) => {
    const { translate } = useTranslate();

    // A count of zero while loading is the initial state, not an answer.
    if (isLoading && !totalCount) {
        return (
            <CountPlaceholder
                width={COUNT_PLACEHOLDER_WIDTH}
                height={COUNT_PLACEHOLDER_HEIGHT}
                data-automation={dataAutomation}
            />
        );
    }

    return (
        <Title data-automation={dataAutomation}>
            {numberFilter()(totalCount)} {translate(labelKey)}
        </Title>
    );
};
